var map = {
	"./filter-boxes-icon-active.svg": 86060,
	"./filter-campaigns-icon-active.svg": 52366,
	"./filter-diabetes-icon-active.svg": 42180,
	"./filter-emergency-icon-active.svg": 33504,
	"./filter-hospitals-icon-active.svg": 89798,
	"./filter-lockit-icon-active.svg": 21297,
	"./filter-patients-icon-active.svg": 21121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2803;